import { Dimensions, Platform, StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  subHeaderBeforeSubTitleStyle: {
    textDecorationLine: 'line-through',
  },
  scrollviewContainer: {
    paddingBottom: 150,
    paddingHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? '10%' : 16,
    overflow: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : "scroll"
  },
  stepperContainer: {
    marginTop: 0,
    paddingVertical: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 15,
  },
})

export default styles
